import React from 'react'
import {makeStyles} from 'external/material'
import Fade from '@mui/material/Fade'
import Box from '@mui/material/Box'
import InfoBar from './info-bar'
import WriteComments from './write-comments'
import Dialog from '../../../responsive-fullscreen-dialog'


const useStyles = makeStyles(commentsStyles)

export default function Comments (props) {

  const classes = useStyles()
  const {isOpen, closeDialog, context} = props

  return (
    <Dialog
      open={isOpen}
      close={closeDialog}
      dialogClassName={classes.root}
      dialogMaxWidth="lg"
      TitleComponent={() => (
        <InfoBar {...props} />
      )}
    >
      <WriteComments context={context} />
    </Dialog>
  )
}

function commentsStyles(theme) {
  return {
    root: {
      '& .MuiDialog-paper': {
        minHeight: 'calc(100% - 30px)',
        flexGrow: 1
      },
      '& .MuiDialogTitle-root': {
        padding: 0
      }
    },
  }
}
